import { gql, TypedDocumentNode } from '@apollo/client';
import { PaymentSource } from '../../constants';
import { ORDER_SUMMARY_FRAGMENT, OrderSummary } from '../useOrderSummary';

export type PlaceOrderMutationInput = {
  data: {
    type: 'orders';
    attributes: {
      address_id: number;
      cart_id: string;
      country_code: string;
      event_source?: string;
      offer_code: string | null;
      order_session_id: string | null;
      payment_id: number;
      payment_source: PaymentSource;
      shipment_method: number;
      linkshare?: string;
      ga_id?: string;
      ga_tracking_id?: string;
      segment_id?: string;
      payment_token?: string;
      other_payment_details?: OtherPaymentDetails;
      payment_summary?: PaymentSummary;
    };
  };
};

export type PaymentSummary = {
  first_name: string;
  last_name: string;
  address_line1: string;
  address_line2: string;
  city: string;
  state: string;
  postal_code: string;
  country_code: string;
};

export type OtherPaymentDetails = {
  card_type: string;
  last_four: string;
  source: string;
};

export type PlaceOrderMutationVariables = {
  input: PlaceOrderMutationInput;
};

export type PlaceOrderMutation = {
  checkout: {
    data: OrderSummary[];
  };
};

export const PLACE_ORDER_MUTATION: TypedDocumentNode<
  PlaceOrderMutation,
  PlaceOrderMutationVariables
> = gql`
  mutation PlaceOrderMutation($input: PlaceOrderMutationInput!) {
    checkout(input: $input)
      @rest(type: "RestPlaceOrder", endpoint: "cart", path: "/v3.5/orders", method: "POST") {
      data @type(name: "RestOrderSummary") {
        ...OrderSummaryFragment
      }
    }
  }
  ${ORDER_SUMMARY_FRAGMENT}
`;
